import { getOverridesByPrefix } from "@/lib/copyOverrides";

const ENDPOINT = "https://jhgvpqnesquocndbzygl.supabase.co/functions/v1/promo-events";
const SITE = "sons-blue-river";

const sentViews = new Set<string>();

function skip(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1" || host.includes("lovable")) return true;
    if (new URLSearchParams(window.location.search).has("promo_preview")) return true;
  } catch {
    return true;
  }
  return false;
}

async function hashValues(surface: "banner" | "popup"): Promise<string> {
  const values = getOverridesByPrefix(`${surface}.`);
  const sorted = Object.fromEntries(
    Object.entries(values).sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
  );
  const json = Object.keys(sorted).length ? JSON.stringify(sorted) : "{}";
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(json));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export function sendPromoEvent(surface: "banner" | "popup", event: "view" | "click"): void {
  if (skip()) return;
  try {
    void (async () => {
      try {
        const body = JSON.stringify({
          site: SITE,
          surface,
          event,
          hash: await hashValues(surface),
          path: window.location.pathname,
          ts: Date.now(),
        });
        const blob = new Blob([body], { type: "application/json" });
        if (!(navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob))) {
          void fetch(ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body,
            keepalive: true,
          }).catch(() => {});
        }
      } catch {
        /* silent */
      }
    })();
  } catch {
    /* silent */
  }
}

export function sendPromoViewOnce(surface: "banner" | "popup", path: string): void {
  const k = `${surface}:${path}`;
  if (sentViews.has(k)) return;
  sentViews.add(k);
  sendPromoEvent(surface, "view");
}
